/*
  HLL visual pass: the two buttons at the bottom of the filter panel
  (collection pages and search results).

  The theme applies a filter the moment it is picked, reloads the product
  grid and closes the panel. That is not changed here. This only wires up:
    Apply  closes the panel
    Reset  clears every filter, keeps the sort order (and the search words
           on the search page), and reloads the page

  The theme rebuilds the panel each time the grid reloads, so the clicks
  are caught on the page, not on the buttons themselves.
*/
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-hll-filter-apply]')) {
      if (window.theme && window.theme.FilterDrawer) window.theme.FilterDrawer.close();
      return;
    }

    if (target.closest('[data-hll-filter-reset]')) {
      event.preventDefault();
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf('filter.') === 0 || key === 'page') url.searchParams.delete(key);
      });
      var query = url.searchParams.toString();
      window.location.href = url.pathname + (query ? '?' + query : '');
    }
  });
})();
